import { GeneralCode, Interface, InterfaceListPageState } from ".";
import { INIT_ERROR_RESULT_DATA } from "../../util";
import { ENV } from "@vrf/fr-vrf-core";
import { INIT_ROW_IDX, REVIEW_DIFF_TARGET } from "./InterfaceListPageConstant";

export const generalCodeInitialState: GeneralCode = {
  commonConditionFlagType: [],
  securityContentsType: [],
  sendDatalakeType: [],
  fileExtensionType: [],
  referenceModeType: [],
  godReferenceModeType: [],
  reviewActionType: [],
  reviewingActionType: [],
  designCompletedActionType: [],
  interfaceRequirementType: [],
  interfaceUpdateRequirementType: [],
  edhNotificationType: [],
  edhPrtclType: [],
  inboundEdhProtocolList: [],
  outboundEdhProtocolList: [],
  ptnrType: [],
  chnTypeType: [],
  srcEdiChainTypeList: [],
  dstEdiChainTypeList: [],
  fileTypeType: [],
  ifCycleType: [],
  snapshotIncrementalDeltaType: [],
  dataScopeType: [],
  encriptionType: [],
  securityInformationLevelType: [],
  tcktStsTypePrjPrgrs: [],
  dipByRgnOrDipList: [],
  dipByRegionList: [],
  retentionPeriodDays: [],
  ediPollingAdaptorType: [],
  interruptType: [],
};
const displayColumn = [
  { label: "Deployment Group Tag", value: "project.dplymntGrpTag" },
  { label: "Event Group Type", value: "evntGrpTypeCd" },
];

export const INIT_FILE_LIST = [{ label: "-", value: "-" }];

export const INIT_INTERFACE_DATA = {
  ...INIT_ERROR_RESULT_DATA,
  isAddRow: false,
  cancelledRequirement: false,
  srcDipSelect: false,
  dstDipSelect: false,
  srcFileList: [...INIT_FILE_LIST],
  dstFileList: [...INIT_FILE_LIST],
  srcInboundOutputFileList: [...INIT_FILE_LIST],
  dstInboundOutputFileList: [...INIT_FILE_LIST],
};

export const INIT_CREATE_FILE_LAYOUT_CONFIRM_DIALOG_STATE = {
  isShow: false,
};

export const INIT_REVIEW_DIFF_STATE = {
  selectedTarget: REVIEW_DIFF_TARGET.NONE,
  response: null,
};

export const InterfaceListPageInitialState: InterfaceListPageState = {
  authorized: false,
  alertMessage: {},
  prevActionSuccessMessage: "",
  title: "",
  isPendingDisplay: false,
  isHistoryDisplay: false,
  issuedRowIdx: INIT_ROW_IDX,
  issuedEventName: "",
  deploymentMode: "",
  dfnSetVerNum: ENV("REACT_APP_DFN_SET_VER_NUM"),
  dplymntDate: "",
  dplymntTime: "",
  searchForm: {
    srcDipByRgnOrDip: "",
    srcIfId: "",
    srcInbdId: "",
    srcInbdCpntId: "",
    dstDipByRgnOrDip: "",
    dstIfId: "",
    dstOtbdId: "",
    dstOtbdCpntId: "",
    interfaceNameEnglish: "",
    interfaceNameJapanese: "",
  },
  spreadsheetSelectedRowIndex: undefined,
  comment: {
    commentDescription: "",
    selectedEvent: "",
    ifList: {} as Interface,
  },
  interfaceListGeneralCodeState: generalCodeInitialState,
  edhNotificationType: {},
  ifList: [],
  editedIfList: [],
  retentionEditedIfList: new Map<string, any>(),
  displayColumn: displayColumn,
  createFileLayoutConfirmDialogState:
    INIT_CREATE_FILE_LAYOUT_CONFIRM_DIALOG_STATE,
  isSaveAuth: false,
  reviewDiffState: INIT_REVIEW_DIFF_STATE,
};
